import { v4 as uuidv4 } from 'uuid'

import { safeLocalStorage } from '@hooks/useStorage'

import type { BrowserClientInfo } from './types'

export const NOTIFICATION_HUB_PATH = '/api/ws/v1'

const DEVICE_ID_STORAGE_KEY = 'tmca:websocket:device-id'

export const getOrCreateDeviceId = (): string => {
  if (typeof window === 'undefined') return uuidv4()

  const existingDeviceId = safeLocalStorage.getItem(DEVICE_ID_STORAGE_KEY)
  if (existingDeviceId) return existingDeviceId

  const deviceId = uuidv4()
  safeLocalStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId)
  return deviceId
}

export const collectBrowserClientInfo = (deviceId: string, tabId: string): BrowserClientInfo => {
  if (typeof window === 'undefined') return { deviceId, tabId }

  const navigatorObject = window.navigator as Navigator & { deviceMemory?: number }

  return {
    deviceId,
    tabId,
    userAgent: navigatorObject.userAgent,
    platform: navigatorObject.platform,
    language: navigatorObject.language,
    languages: Array.from(navigatorObject.languages ?? []),
    hardwareConcurrency: navigatorObject.hardwareConcurrency,
    deviceMemory: navigatorObject.deviceMemory,
    maxTouchPoints: navigatorObject.maxTouchPoints,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }
}

export const buildNotificationHubWebSocketUrl = (): string | null => {
  if (typeof window === 'undefined') return null
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'

  return `${protocol}//${window.location.host}${NOTIFICATION_HUB_PATH}`
}
